<template>
    <th :class="{'text-right': right, 'text-center': center}" :style="{width: shrink ? '1px': grow ? '100%' : undefined}" :sortable="sortable">
        <template v-if="sortable">
            <div class="d-inline-flex">
                <slot/>

                <span class="sort-container">
                    <i v-if="sortedDirection === 'asc'" class="sort-icon lely-icon-caret-up"/>
                    <i v-else-if="sortedDirection === 'desc'" class="sort-icon lely-icon-caret-down"/>
                </span>
            </div>
        </template>
        <template v-else>
            <slot/>
        </template>

        <span v-if="$slots.sub" class="sub">
            <slot name="sub"/>
        </span>
    </th>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class LelyTableHeader extends Vue {
    @Prop({type: Boolean})
    public shrink!: boolean;

    @Prop({type: Boolean})
    public grow!: boolean;

    @Prop({type: Boolean})
    public right!: boolean;

    @Prop({type: Boolean})
    public center!: boolean;

    @Prop({type: Boolean})
    public sortable!: boolean;

    @Prop({type: String, default: null})
    public sortedDirection!: 'asc' | 'desc' | null;


}

</script>

<style lang="scss" scoped>
th {
    vertical-align: middle;
    white-space: nowrap !important;
}

.sub {
    display: block;
    font-size: 12px;
}

.sort-container {
    width: 20px;
}

.sort-icon {
    position: relative;
    top: 3px;
}

</style>
